export function convertSortToQuery(sort: any) {
  if (!sort || !sort.field || !sort.order) {
    return "";
  }

  const field = sort.field;
  const order = sort.order === "asc" ? "asc" : "desc"; // Bảo đảm thứ tự là 'asc' hoặc 'desc'

  return `_sort=${(field)}%40${order}`;
}
